import API from "Api";
import { generateDynamicEndpoint } from "utils/generalUtils";
import {
  GET_COLLECTION_LIST_ENDPOINT,
  DELETE_COLLECTION_ENDPOINT,
  GET_COLLECTION_COUNT_ENDPOINT,
  GET_COLLECTION_DETAIL_ENDPOINT,
  UPDATE_COLLECT_DATA_ENDPOINT,
  UPDATE_ADD_AND_UPDATE_NOTE_ENDPOINT,
  DELETE_NOTE_ENDPOINT,
  COLLECT_AND_REMOVE_ENDPOINT,
  COLLECT_MARK_AS_URGENT_ENDPOINT,
  GET_CREATE_RX_ENDPOINT,
  UPDATE_CHASEUP_ENDPOINT,
  UPDATE_DRUG_NAME_ENDPOINT,
  ARCHIVE_COLLECTION,
  COMPLETE_COLLECTION,
  COLLECTED_AND_REMOVED_ENDPOINT,
} from "./endpoints";

//Get Group List
export const getCollectionListAPI = (payload) => {
  return API.post(GET_COLLECTION_LIST_ENDPOINT, payload);
};

//Get Collect & UnCollect Count
export const getCollectionCountAPI = (payload) => {
  return API.post(GET_COLLECTION_COUNT_ENDPOINT, payload);
};

//Delete Group
export const deleteCollectionAPI = (id) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_COLLECTION_ENDPOINT, { collection_id: id })
  );
};
export const ArchiveCollectionAPI = (payload) => {
  return API.post(ARCHIVE_COLLECTION, payload);
};

export const CompleteCollectionAPI = (payload) => {
  return API.post(COMPLETE_COLLECTION, payload);
};

//Collection details
export const getCollectionViewRxDetailsAPI = (id, payload) => {
  return API.get(
    generateDynamicEndpoint(GET_COLLECTION_DETAIL_ENDPOINT, {
      collection_id: id,
    }),
    payload
  );
};

//Update Collect
export const updateCollectDataAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_COLLECT_DATA_ENDPOINT, {
      collection_id: id,
    }),
    payload
  );
};

//Add & update note
export const updateAddAndUpdateNoteAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_ADD_AND_UPDATE_NOTE_ENDPOINT, {
      collection_id: id,
    }),
    payload
  );
};

//Delete note
export const deleteNoteAPI = (id, payload) => {
  return API.deleteM(
    generateDynamicEndpoint(DELETE_NOTE_ENDPOINT, { collection_id: id }),
    payload
  );
};

//Collect and remove medication
export const collectAndRemoveAPI = (id, payload) => {
  return API.post(
    generateDynamicEndpoint(COLLECT_AND_REMOVE_ENDPOINT, { collection_id: id }),
    payload
  );
};
//Collect and remove medication
export const collectedAndRemovedAPI = (id, payload) => {
  return API.post(
    generateDynamicEndpoint(COLLECTED_AND_REMOVED_ENDPOINT, {
      collection_id: id,
    }),
    payload
  );
};

//Mark as urgent collect
export const markAsUrgentAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(COLLECT_MARK_AS_URGENT_ENDPOINT, {
      collection_id: id,
    }),
    payload
  );
};

// Create  RX
export const createRxAPI = (payload) => {
  return API.post(GET_CREATE_RX_ENDPOINT, payload);
};

/**chase up update */
export const createChaseup = (payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_CHASEUP_ENDPOINT, {
      collection_id: payload.id,
    }),
    payload
  );
};
/**drugs medi edit  */
export const updateDrugNameAPI = (id, payload) => {
  return API.put(
    generateDynamicEndpoint(UPDATE_DRUG_NAME_ENDPOINT, { id: id }),
    payload
  );
};
